import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Mascot from '../components/Mascot';
import StreakBadge from '../components/StreakBadge';
import { computeStreak } from '../lib/streak';

const entries = [
  { to: '/snap', title: 'Snap a problem', blurb: 'Point your camera at the page', color: 'bg-coral/10' },
  { to: '/type', title: 'Type a question', blurb: "Or paste it in — we'll work through it", color: 'bg-sky/10' },
  { to: '/browse', title: 'Browse chapters', blurb: 'Jump to any topic in the book', color: 'bg-violet/15' },
];

export default function Home() {
  const [streak, setStreak] = useState(0);
  useEffect(() => {
    computeStreak().then(setStreak);
  }, []);

  return (
    <div className="max-w-xl mx-auto px-5 pt-10 safe-top space-y-8">
      <header className="flex items-center gap-4">
        <Mascot mood="happy" size={96} />
        <div>
          <div className="font-display font-black text-sky text-lg leading-none tracking-tight">
            Grace Math
          </div>
          <h1 className="font-display font-black text-2xl leading-tight mt-1">
            Hi, Grace
          </h1>
          <p className="text-ink/70 text-sm">Let's work through something together.</p>
          <div className="mt-2">
            <StreakBadge streak={streak} />
          </div>
        </div>
      </header>

      <div className="space-y-3">
        {entries.map((e) => (
          <Link
            key={e.to}
            to={e.to}
            className={`card p-5 flex items-center justify-between ${e.color} block transition hover:-translate-y-0.5`}
          >
            <div>
              <div className="font-display text-xl text-ink">{e.title}</div>
              <div className="text-sm text-ink/70">{e.blurb}</div>
            </div>
            <span className="text-2xl">→</span>
          </Link>
        ))}
      </div>

      <div className="pt-4 text-center text-xs text-ink/50">
        <Link to="/parent/login" className="underline underline-offset-4">
          Parent sign in
        </Link>
      </div>
    </div>
  );
}
